import { render, staticRenderFns } from "./CheckListBaseForm.vue?vue&type=template&id=27c40852&scoped=true"
import script from "./CheckListBaseForm.vue?vue&type=script&lang=js"
export * from "./CheckListBaseForm.vue?vue&type=script&lang=js"
import style0 from "./CheckListBaseForm.vue?vue&type=style&index=0&id=27c40852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c40852",
  null
  
)

export default component.exports